module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/title03-f1de533e5b96356eede2c962f41ddf28.svg";